import { addDoc, collection, Timestamp } from "firebase/firestore";
import { db } from "../Config/firebase";
import { aplicarTenant } from "./tenant";

function obterIdentificadoresCriador(registro = {}) {
  const candidatos = [
    registro.criadoPorUid,
    registro.createdByUid,
    registro.criadoPor?.uid,
    registro.createdBy?.uid,
    registro.criadoPor,
    registro.createdBy,
    registro.criadoPorEmail,
    registro.createdByEmail,
    registro.criadoPor?.email,
    registro.createdBy?.email,
  ];

  return [...new Set(candidatos
    .filter((valor) => typeof valor === "string" && valor.trim())
    .map((valor) => valor.trim()))];
}

export function obterCriadorUid(registro = {}) {
  return obterIdentificadoresCriador(registro)[0] || "";
}

export function podeEditarCadastroDireto(usuario, registro = {}) {
  const tipoUsuario = String(usuario?.tipo || "").trim().toLowerCase();
  if (usuario?.isSuperadmin || usuario?.isAdmin || tipoUsuario === "admin") {
    return true;
  }

  if (!(usuario?.isColaborador || tipoUsuario === "colaborador")) {
    return false;
  }

  const usuarioUid = String(usuario?.uid || "").trim();
  const usuarioEmail = String(usuario?.email || "").trim().toLowerCase();
  const identificadoresCriador = obterIdentificadoresCriador(registro);

  return identificadoresCriador.some((identificador) =>
    (usuarioUid && identificador === usuarioUid) ||
    (usuarioEmail && identificador.toLowerCase() === usuarioEmail)
  );
}

export async function solicitarAprovacaoCadastro({
  usuario,
  registro,
  colecao,
  registroId,
  dados,
  tipo,
  titulo,
}) {
  if (!usuario?.uid || !usuario?.tenantId || !colecao || !registroId) {
    throw new Error("DADOS_APROVACAO_INCOMPLETOS");
  }

  return addDoc(
    collection(db, "aprovacoes"),
    aplicarTenant(
      {
        tipo: tipo || "cadastro",
        titulo: titulo || "Alteração de cadastro",
        colecao,
        registroId,
        dadosAtuais: registro || {},
        dadosSolicitados: dados || {},
        status: "pendente",
        solicitadoPor: {
          uid: usuario.uid,
          nome: usuario.nome || "",
          email: usuario.email || "",
          tipo: usuario.tipo || "colaborador",
        },
        criadoEm: Timestamp.now(),
      },
      usuario
    )
  );
}
